export const environment = {
  production: false,
  apiUrl: 'https://api.borafestejar.com.br/',
};
